import { countLayerItems, LayerKind, type PlanLayers } from "@/shared/plan";

export interface ExportPageSpec {
	title: string;
	layers: readonly LayerKind[];
	/** Слои, материалы и предметы которых выводим в легенду этого листа. */
	legendLayers?: readonly LayerKind[];
	/** Объекты этих слоёв получают выноски с позицией на чертеже. */
	markLayers?: readonly LayerKind[];
	/** Слои с данными, по которым решаем, нужен ли отдельный лист. */
	contentLayers?: readonly LayerKind[];
	/** Размерные цепочки выводятся только на специальном листе размеров. */
	showDimensions?: boolean;
	/** Служебный лист размеров не содержит площадей и комментариев. */
	wallsOnly?: boolean;
}

const EXPORT_PAGE_SPECS: readonly ExportPageSpec[] = [
	{
		title: "Общий план",
		layers: [
			LayerKind.Walls,
			LayerKind.Floors,
			LayerKind.Waterproof,
			LayerKind.Screed,
			LayerKind.Furniture,
			LayerKind.Plumbing,
			LayerKind.Electrical,
			LayerKind.Wiring,
			LayerKind.Pipes,
		],
	},
	{
		title: "Размеры",
		layers: [LayerKind.Walls],
		showDimensions: true,
		wallsOnly: true,
	},
	{
		title: "Стены и проёмы",
		layers: [LayerKind.Walls],
		legendLayers: [LayerKind.Walls],
		contentLayers: [LayerKind.Walls],
	},
	{
		title: "Пол",
		layers: [LayerKind.Walls, LayerKind.Floors],
		legendLayers: [LayerKind.Floors],
		contentLayers: [LayerKind.Floors],
	},
	{
		title: "Потолок",
		layers: [LayerKind.Walls, LayerKind.Ceiling],
		contentLayers: [LayerKind.Ceiling],
		legendLayers: [LayerKind.Ceiling],
	},
	{
		title: "Стяжка",
		layers: [LayerKind.Walls, LayerKind.Screed],
		contentLayers: [LayerKind.Screed],
		legendLayers: [LayerKind.Screed],
	},
	{
		title: "Гидроизоляция",
		layers: [LayerKind.Walls, LayerKind.Waterproof],
		contentLayers: [LayerKind.Waterproof],
		legendLayers: [LayerKind.Waterproof],
	},
	{
		title: "Мебель",
		layers: [LayerKind.Walls, LayerKind.Furniture],
		legendLayers: [LayerKind.Furniture],
		markLayers: [LayerKind.Furniture],
		contentLayers: [LayerKind.Furniture],
	},
	{
		title: "Сантехника",
		layers: [LayerKind.Walls, LayerKind.Plumbing],
		contentLayers: [LayerKind.Plumbing],
		legendLayers: [LayerKind.Plumbing],
		markLayers: [LayerKind.Plumbing],
	},
	{
		title: "Электрика",
		layers: [LayerKind.Walls, LayerKind.Electrical],
		contentLayers: [LayerKind.Electrical],
		legendLayers: [LayerKind.Electrical],
		markLayers: [LayerKind.Electrical],
	},
	{
		title: "Электрика + Проводка",
		layers: [LayerKind.Walls, LayerKind.Electrical, LayerKind.Wiring],
		contentLayers: [LayerKind.Electrical, LayerKind.Wiring],
		legendLayers: [LayerKind.Electrical, LayerKind.Wiring],
		markLayers: [LayerKind.Electrical],
	},
	{
		title: "Водоснабжение + Сантехника",
		layers: [LayerKind.Walls, LayerKind.Pipes, LayerKind.Plumbing],
		contentLayers: [LayerKind.Pipes, LayerKind.Plumbing],
		legendLayers: [LayerKind.Pipes, LayerKind.Plumbing],
		markLayers: [LayerKind.Plumbing],
	},
];

export const exportPageSpecs = (layers: PlanLayers, includeDimensions: boolean) =>
	EXPORT_PAGE_SPECS.filter(
		(page) =>
			(includeDimensions || !page.showDimensions) &&
			(page.contentLayers === undefined ||
				page.contentLayers.some((layer) => countLayerItems(layers, layer) > 0)),
	);
